export default {
  companyList:{},
  companyValuePairs:[],
  companyData: {},
  sapCompanyDataList: [],
  companyDebitBalance: {},
  freeReservationCredit: null
};



// WEBPACK FOOTER //
// ./src/store/modules/company/state.js